import React, { useEffect, useLayoutEffect } from 'react';
import styles from './LayoutUsuario.module.css';
import {
  mdiAccountBox,
  mdiAccountClock,
  mdiAccountEdit,
  mdiAccountGroup,
  mdiAccountStar,
  mdiApi,
  mdiBullhorn,
  mdiCalendar,
  mdiCalendarAccount,
  mdiCardAccountDetails,
  mdiCardAccountPhone,
  mdiChartAreaspline,
  mdiBookmarkMultiple,
  mdiCashMinus,
  mdiCashSync,
  mdiChartBarStacked,
  mdiCog,
  mdiCreation,
  mdiEyeCircleOutline,
  mdiCurrencyBrl,
  mdiFaceAgent,
  mdiFilter,
  mdiClipboardTextClock,
  mdiHeadCogOutline,
  mdiHistory,
  mdiInvoiceImport,
  mdiLanDisconnect,
  mdiLanPending,
  mdiMenu,
  mdiMenuOpen,
  mdiMessage,
  mdiMessageBookmark,
  mdiMessageText,
  mdiOfficeBuilding,
  mdiPhone,
  mdiPhoneClock,
  mdiReceiptText,
  mdiRepeat,
  mdiSchool,
  mdiSitemap,
  mdiStar,
  mdiTag,
  mdiTextBoxEdit,
  mdiTrophyAward,
  mdiLifebuoy,
  mdiVolumeOff,
  mdiViewDashboard,
  mdiWrenchCog,
  mdiZipBox,
  mdiTable,
  mdiCurrencyUsd,
  mdiFormSelect,
  mdiHeart,
  mdiConnection,
} from '@mdi/js';
import { useAuth } from '../../lib/useAuth';
import Icon from '@/components/Icon';
import Botao from '../Botao';
import { rolesAdmin, rolesManager, rolesUser } from '@tera/shared/src/lib/auth';
import NavCategorias from './NavCategorias';
import NavItens from './NavItens';
import NavItem from './NavItem';
import { useAlertas } from '@/lib/useAlertas';
import { ModalAlterarSenha } from './ModalAlterarSenha';
import ModalAjuda from './ModalAjuda';
// Importa apenas o singleton do socket; evita criar novas instâncias por página
import { toast } from 'react-toastify';
import HBox from '../layout/HBox';
import { useReward } from 'react-rewards';
import OnboardingModal from '../OnboardingModal';

import { socket } from './socket';
import { queryClient } from '@/queryClient';
import { useUserInteracted } from '@/hooks/useUserInteracted';
import { useAtendimentoNotificacoes } from '@/contexts/AtendimentoNotificacoesContext';

type NavCagetoria = {
  label: string;
  icon: string;
  itens: Navegacao[];
};

type Navegacao = {
  label: string;
  icon: string;
  roles: string[];
  path: string;
  important?: boolean;
};

const navegacao: NavCagetoria[] = [
  {
    label: 'Atendimento',
    icon: mdiMessage,
    itens: [
      {
        label: 'Chats',
        icon: mdiMessage,
        roles: rolesUser,
        path: '/chat',
        important: true,
      },
      {
        label: 'Filas de atendimento',
        icon: mdiAccountClock,
        roles: rolesManager,
        path: '/fila_atendimento',
      },
      {
        label: 'Filas de ligações',
        icon: mdiPhoneClock,
        roles: rolesManager,
        path: '/fila_ligacao',
      },
    ],
  },
  {
    label: 'CRM',
    icon: mdiStar,
    itens: [
      {
        label: 'Contatos',
        important: true,
        icon: mdiCardAccountPhone,
        roles: rolesManager,
        path: '/cliente',
      },
      {
        label: 'Dashboard',
        icon: mdiViewDashboard,
        roles: rolesUser,
        path: '/crm_dashboard',
      },
      {
        label: 'Campanhas',
        icon: mdiBullhorn,
        roles: rolesManager,
        path: '/campanha_mensagem',
      },
      {
        label: 'Vendas',
        icon: mdiStar,
        roles: rolesUser,
        path: '/venda',
      },
      {
        label: 'Minhas atividades',
        icon: mdiAccountClock,
        roles: rolesUser,
        path: '/atividade',
      },
      {
        label: 'Produtos',
        icon: mdiZipBox,
        roles: rolesManager,
        path: '/produto',
      },
      {
        label: 'Grupos de contatos',
        icon: mdiCardAccountDetails,
        roles: rolesUser,
        path: '/cliente_grupo',
      },
      {
        label: 'Funil de vendas',
        icon: mdiFilter,
        roles: rolesAdmin,
        path: '/funil_venda',
      },
      {
        label: 'Agendas',
        icon: mdiCalendarAccount,
        roles: rolesManager,
        path: '/agenda',
      },
      {
        label: 'Empresas',
        icon: mdiOfficeBuilding,
        roles: rolesManager,
        path: '/empresa',
      }
    ],
  },
  {
    label: 'Tickets',
    icon: mdiFaceAgent,
    itens: [
      {
        important: true,
        label: 'Tickets de suporte',
        icon: mdiTextBoxEdit,
        roles: rolesUser,
        path: '/ticket',
      }
    ]
  },
  {
    label: 'Financeiro',
    icon: mdiCurrencyBrl,
    itens: [
      {
        label: 'Lançamentos',
        icon: mdiCashMinus,
        roles: rolesManager,
        path: '/lancamento_financeiro',
      },
      {
        label: 'Categorias Financeiras',
        icon: mdiTag,
        roles: rolesManager,
        path: '/categoria_financeira',
      },
      {
        label: 'Centro de Custos',
        icon: mdiSitemap,
        roles: rolesManager,
        path: '/centro_custo',
      },
      {
        label: 'Recorrências',
        icon: mdiRepeat,
        roles: rolesManager,
        path: '/lancamento_financeiro_recorrencia',
      },
    ],
  },
  {
    label: 'Gestão',
    icon: mdiWrenchCog,
    itens: [
      {
        label: 'Canais de atendimento',
        icon: mdiPhone,
        roles: rolesManager,
        path: '/canal',
      },
      {
        label: 'Fluxos de atendimento',
        icon: mdiSitemap,
        roles: rolesManager,
        path: '/dialogo',
      },
      {
        label: 'Integrações',
        icon: mdiApi,
        roles: rolesManager,
        path: '/integrations',
      },
      {
        label: 'Estruturas de dados',
        icon: mdiZipBox,
        roles: rolesManager,
        path: '/estrutura_dados',
      },
      {
        label: 'Tabelas de dados',
        icon: mdiTable,
        roles: rolesManager,
        path: '/dataset',
      },
      {
        label: 'Catálogos de orçamento',
        icon: mdiCurrencyUsd,
        roles: rolesManager,
        path: '/catalogo',
      },
      {
        label: 'Orçamentos',
        icon: mdiReceiptText,
        roles: rolesManager,
        path: '/orcamentos',
      },
      {
        label: 'Mini formulários',
        icon: mdiFormSelect,
        roles: rolesManager,
        path: '/mini_formulario',
      },
      {
        label: 'Base de conhecimento',
        icon: mdiSchool,
        roles: rolesManager,
        path: '/base_conhecimento',
      },
      {
        label: 'Agentes de IA',
        icon: mdiCreation,
        roles: rolesManager,
        path: '/ia_agente',
      },
      {
        label: 'Servidores MCP',
        icon: mdiConnection,
        roles: rolesManager,
        path: '/mcp_servidor',
      },
      {
        label: 'Supervisão de IA',
        icon: mdiEyeCircleOutline,
        roles: rolesManager,
        path: '/ia/supervisao',
      },
      {
        label: 'Modelos de mensagem',
        icon: mdiTextBoxEdit,
        roles: rolesManager,
        path: '/mensagem_programada',
      },
      {
        label: 'Atalhos de mensagem',
        icon: mdiMessageBookmark,
        roles: rolesManager,
        path: '/atalho_mensagem',
      },
      {
        label: 'Marcadores',
        icon: mdiTag,
        roles: rolesManager,
        path: '/marcador',
      },
      {
        label: 'Campanhas',
        icon: mdiBullhorn,
        roles: rolesManager,
        path: '/campanha_movida',
      },
      {
        label: 'Usuários',
        icon: mdiAccountBox,
        roles: rolesManager,
        path: '/usuario',
      },
      {
        label: 'Grupos / Departamentos',
        icon: mdiAccountGroup,
        roles: rolesManager,
        path: '/usuario_grupo',
      },
      {
        label: 'Calendário',
        icon: mdiCalendar,
        roles: rolesManager,
        path: '/calendario',
      },
      {
        label: 'Chat Interno',
        icon: mdiMessageText,
        roles: rolesManager,
        path: '/chat_interno',
      },
    ],
  },
  {
    label: 'Relatórios',
    icon: mdiChartBarStacked,
    itens: [
      {
        label: 'Mensagens e atendimentos',
        icon: mdiChartAreaspline,
        roles: rolesManager,
        path: '/relatorios',
      },
      {
        label: 'Histórico de mensagens',
        icon: mdiHistory,
        roles: rolesManager,
        path: '/historico_mensagens',
      },
      {
        label: 'Histórico de ligações',
        icon: mdiPhone,
        roles: rolesUser,
        path: '/ligacao',
      },
      {
        label: 'Vendas',
        icon: mdiStar,
        roles: rolesManager,
        path: '/relatorios/vendas',
      },
      {
        label: 'Financeiro',
        icon: mdiChartAreaspline,
        roles: rolesManager,
        path: '/relatorios/financeiro',
      },
      {
        label: 'Fluxo de Caixa',
        icon: mdiCashSync,
        roles: rolesManager,
        path: '/relatorios/fluxo_caixa',
      },
      {
        label: 'Atendimento Humano',
        icon: mdiAccountStar,
        roles: rolesManager,
        path: '/relatorios/atendimento_humano',
      },
      {
        label: 'Relatórios Personalizados',
        icon: mdiBookmarkMultiple,
        roles: rolesManager,
        path: '/relatorios/salvos',
      },
      {
        label: 'Auditoria',
        icon: mdiClipboardTextClock,
        roles: rolesAdmin,
        path: '/auditoria',
      },
      {
        label: 'Classificador de texto',
        icon: mdiHeadCogOutline,
        roles: rolesAdmin,
        path: '/ia_classificacao',
      },
    ],
  },
];

const navPerfil = [
  {
    label: 'Avalie-nos!',
    icon: mdiStar,
    roles: rolesManager,
    path: '/chat',
  },
  {
    label: 'Meu perfil',
    icon: mdiAccountEdit,
    roles: rolesManager,
    path: '/perfil',
  },
  {
    label: 'Configurações',
    icon: mdiCog,
    roles: rolesManager,
    path: '/configuracoes',
  },
  {
    label: 'Sair',
    icon: mdiInvoiceImport,
    roles: rolesManager,
    path: '/logout',
  },
];

const LayoutUsuario = ({ children }: { children: React.ReactNode }) => {
  const { user, setUser, organizacao } = useAuth();
  const { notificacoesAtendimento, filaAtendimento } = useAtendimentoNotificacoes();
  const { ativos: alertasAtivos } = useAlertas();

  // O logo é o opt-in da marca própria: sem upload, a sidebar mantém a marca
  // Terachat inteira (logo + nome), mesmo que a organização tenha nome fantasia.
  const marcaPropria = !!organizacao?.tem_logo;
  const nomeMarca = marcaPropria ? organizacao?.nome_fantasia : null;

  const [menuOpen, setMenuOpen] = React.useState(false);
  const [showModalAjuda, setShowModalAjuda] = React.useState(false);
  const [mouseOverCats, setMouseOverCats] = React.useState(false);
  const [mouseOverItens, setMouseOverItens] = React.useState(false);
  const [selected, setSelected] = React.useState<string | null>(
    navegacao[0].label,
  );

  const [showModalAlterarSenha, setShowModalAlterarSenha] = React.useState(user?.trocar_senha_proximo_login);

  const userInteracted = useUserInteracted();
  const [userConnected, setUserConnected] = React.useState<Boolean | null>(socket.connected);

  useLayoutEffect(() => {
    if (!navigator.serviceWorker) return;

    navigator.serviceWorker
      .register('/service-worker.js')
  }, [navigator.serviceWorker]);

  useEffect(() => {
    if (!menuOpen) setSelected(null);
  }, [menuOpen]);

  useEffect(() => {
    if (!mouseOverCats && !mouseOverItens) setSelected(null);
  }, [mouseOverCats, mouseOverItens]);

  const { reward, isAnimating } = useReward('add-achievement', 'confetti', { angle: 270, startVelocity: 20, spread: 180 });

  useEffect(() => {
    console.log('socket init /notifications');
    socket.on('achievement', (data) => {
      console.log('Achievement unlocked!', data)

      new Audio('/sounds/conquista.mp3').play().catch(() => {
        console.warn('Erro ao tocar som de conquista alcançada');
      });

      toast(<div style={{ textAlign: 'center' }}>
        <HBox style={{ fontSize: '1.2em', fontWeight: 'bold' }}>
          <Icon path={mdiTrophyAward} size={1.5} style={{ marginRight: '8px' }} />
          {data.titulo}
        </HBox>
        <div>Nova conquista desbloqueada!</div>
      </div>, {
        position: 'top-right',
        theme: 'tutorial',
      })

      setTimeout(() => {
        reward();
      }, 350);
    });

    socket.on('connect', () => {
      console.log('Connected to /notifications');
      setUserConnected(true);
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from /notifications');
      setUserConnected(false);
    });

    const onConnectError = (err: any) => {
      console.warn('Socket connect_error /notifications', err);
      setUserConnected(false);
    };
    socket.on('connect_error', onConnectError);

    const onReconnectAttempt = (attempt: number) => {
      console.log('Socket reconnect_attempt /notifications', attempt);
      setUserConnected(null);
    };
    const onReconnect = (attempt: number) => {
      console.log('Socket reconnect /notifications', attempt);
      setUserConnected(true);
    };
    const onReconnectError = (err: any) => {
      console.warn('Socket reconnect_error /notifications', err);
      setUserConnected(false);
    };
    const onReconnectFailed = () => {
      console.warn('Socket reconnect_failed /notifications');
      setUserConnected(false);
    };

    socket.io.on('reconnect_attempt', onReconnectAttempt);
    socket.io.on('reconnect', onReconnect);
    socket.io.on('reconnect_error', onReconnectError);
    socket.io.on('reconnect_failed', onReconnectFailed);

    socket.on('ticket:novo', (data) => {
      console.log('ticket:novo', data)

      queryClient.invalidateQueries(['tickets']);

      new Audio('/sounds/novo_ticket.mp3').play().catch(() => {
        console.warn('Erro ao tocar som de novo ticket');
      });

      const msg = `Novo ticket #${data.payload.id} - ${data.payload.titulo}`;

      toast(msg, {
        toastId: 'ticket-novo-' + data.payload.id,
        position: 'top-center',
        type: 'info',
        autoClose: 5000,
      });
    });

    socket.on('ticket:atualizar', (data) => {
      console.log('ticket:atualizar', data)

      queryClient.invalidateQueries(['tickets']);
    });

    socket.on('ticket:atividade:nova', (data) => {
      console.log('ticket:atividade:nova', data)

      queryClient.invalidateQueries(['tickets']);

      new Audio('/sounds/novo_ticket.mp3').play().catch(() => {
        console.warn('Erro ao tocar som de novo ticket');
      });

      const msg = `Nova atividade no ticket #${data.payload.ticket.id} - ${data.payload.ticket.titulo}`;

      toast(msg, {
        toastId: 'ticket-atividade-nova-' + data.payload.id,
        position: 'top-center',
        type: 'info',
        autoClose: 5000,
      });
    });

    socket.on('ticket:assumido', (data) => {
      queryClient.invalidateQueries(['tickets']);
    });

    socket.on('ticket:transferido', (data) => {
      console.log('ticket:transferido', data)

      queryClient.invalidateQueries(['tickets']);

      new Audio('/sounds/novo_ticket.mp3').play().catch(() => {
        console.warn('Erro ao tocar som de novo ticket');
      });

      const msg = data.tipo === 'usuario'
        ? `Ticket #${data.payload.id} - ${data.payload.titulo} foi transferido para você`
        : `Ticket #${data.payload.id} - ${data.payload.titulo} foi transferido para o seu grupo / departamento`;


      toast(msg, {
        toastId: 'ticket-transferido-' + data.payload.id,
        position: 'top-center',
        type: 'info',
        autoClose: 5000,
      });
    });

    socket.on('ticket:atividade:mencionado', (data) => {
      console.log('ticket:atividade:mencionado', data)

      queryClient.invalidateQueries(['tickets']);

      new Audio('/sounds/novo_ticket.mp3').play().catch(() => {
        console.warn('Erro ao tocar som de novo ticket');
      });

      const msg = data.mensagem;

      toast(msg, {
        toastId: 'ticket-mencionado-' + data.payload.id,
        position: 'top-center',
        type: 'info',
        autoClose: 5000,
      });
    });

    socket.on('supervisao:concluida', (data: { chatId: number; supervisaoId: number }) => {
      console.log('supervisao:concluida', data);
      queryClient.invalidateQueries(['ia_supervisao_chats']);
      queryClient.invalidateQueries(['chat_supervisao_historico', data.chatId]);
      toast(`Supervisão de IA concluída para o chat #${data.chatId}`, {
        toastId: 'supervisao-concluida-' + data.supervisaoId,
        position: 'top-right',
        type: 'success',
        autoClose: 6000,
      });
    });

    return () => {
      socket.off('achievement');
      socket.off('ticket:novo');
      socket.off('ticket:atualizar');
      socket.off('ticket:atividade:nova');
      socket.off('ticket:transferido');
      socket.off('ticket:assumido');
      socket.off('ticket:atividade:mencionado');
      socket.off('supervisao:concluida');
      socket.off('connect');
      socket.off('disconnect');
      socket.off('connect_error', onConnectError);
      socket.io.off('reconnect_attempt', onReconnectAttempt);
      socket.io.off('reconnect', onReconnect);
      socket.io.off('reconnect_error', onReconnectError);
      socket.io.off('reconnect_failed', onReconnectFailed);
      // Não desconecta aqui para preservar a conexão global entre trocas de rota
      console.log('socket listeners removed /notifications');
    }
  }, [])

  const showLogo = React.useMemo(() => {
    console.log('showLogo', { userConnected, userInteracted });
    return userConnected === true && userInteracted;
  }, [userConnected, userInteracted]);


  if (!user) return null;

  return (
    <div className={styles.container}>
      <OnboardingModal />
      <ModalAjuda
        show={showModalAjuda}
        onClose={() => setShowModalAjuda(false)}
      />
      <ModalAlterarSenha
        show={showModalAlterarSenha}
        onChanged={(updUser) => {
          setShowModalAlterarSenha(false);
          setUser(updUser);
        }} />
      <div
        className={[styles.sidebar, menuOpen ? styles.open : null].join(' ')}
      >
        <div className={[styles.logobar, nomeMarca ? null : 'font-terachat'].join(' ')} style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'baseline' }}>
          <Botao
            className={styles.btnMenu}
            variant="transparent"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <Icon path={menuOpen ? mdiMenuOpen : mdiMenu} size={1.5} />
          </Botao>
          {/* minWidth (e não width) reserva o espaço dos ícones de status sem
              cortar o logo: se ele for mais largo, o slot cresce e o gap é mantido. */}
          <span style={{ minWidth: '24px', height: '32px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            {userConnected === null && <Icon path={mdiLanPending} size={1.5} color="var(--tc-color-warning)" title="Conectando ao servidor de notificações..." className='blink' />}
            {userConnected === false && <Icon path={mdiLanDisconnect} size={1.5} color="var(--tc-color-danger)" title="Desconectado do servidor de notificações" className='blink' />}
            {userConnected === true && !userInteracted && <div style={{ textAlign: 'center' }}><Icon path={mdiVolumeOff} size={1.5} color="var(--tc-color-warning)" title="Clique na tela para ativar o som de novos atendimentos" className='blink' /></div>}
            {showLogo && (
              <img
                src={marcaPropria ? '/api/organizacao/logo' : '/logo.png'}
                alt={nomeMarca ?? 'Logo Terachat'}
                style={{ height: '32px', maxWidth: '40px', objectFit: 'contain' }}
              />
            )}
          </span>
          <span className={styles.nomeMarca}>
            {nomeMarca ? nomeMarca.split(/\s+/g).map((v, i) => <span key={i}>{i % 2 == 0 ? <b>{v}</b> : v}</span>) : <><b>Tera</b>chat</>}
          </span>
        </div>

        <div style={{ width: '100%', position: 'relative' }}>
          <NavCategorias
            value={navegacao}
            selected={selected}
            onSelect={v =>
              setSelected(
                selected === v.label && mouseOverCats ? null : v.label, //mouseOverCats permite que usuários de touch devices possam clicar duas vezes para fechar o menu de itens
              )
            }
            setIsOver={setMouseOverCats}
            badgeMap={{ 'Atendimento': notificacoesAtendimento }}
          />
          {selected != null && (
            <NavItens
              value={navegacao}
              selected={selected}
              setSelected={setSelected}
              setIsOver={setMouseOverItens}
              badgeMap={{ 'Chats': notificacoesAtendimento, 'Filas de atendimento': filaAtendimento }}
            />
          )}
        </div>

        <hr
          style={{
            margin: '4 16px',
            border: 'none',
            borderBottom: '1px solid var(--tc-color-brand-primary)',
          }}
        />

        <div className={styles.containerPerfil}>
          <li
            className={styles.ajudaItem}
            onClick={() => setShowModalAjuda(true)}
            style={{ listStyle: 'none', cursor: 'pointer' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                padding: '2px 8px',
                borderRadius: '4px',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <Icon
                path={mdiLifebuoy}
                size={0.8}
                color="var(--tc-color-brand-primary)"
              />
              <span className="link_name">Ajuda</span>
            </div>
          </li>
          {navPerfil.map(item => (
            <NavItem
              key={item.path}
              value={item}
              alerta={item.path === '/configuracoes' && alertasAtivos.length > 0
                ? `${alertasAtivos.length} alerta(s) ativo(s)`
                : undefined}
            />
          ))}
          {marcaPropria && (
            <div className={styles.creditoTera}>
              feito com
              <Icon path={mdiHeart} size={0.5} />
              por <a href="https://terachat.com.br" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--tc-color-brand-primary)', textDecoration: 'none' }}>
                Tera Sistemas
              </a>
            </div>
          )}
        </div>
      </div>
      <div className={styles.contents}>{children}</div>
    </div>
  );
};

export default LayoutUsuario;
